import MojitoCore from 'mojito/core';
import { useIrreversibleTrue } from 'presentation/hooks';

const log = MojitoCore.logger.get('EventCardsCarousel');

const CardLoader = props => {
    const { cardType, readyToLoad, children } = props;
    const shouldShowCard = useIrreversibleTrue(readyToLoad);

    if (!children) {
        log.error(`Can not find renderer for '${cardType}' card`);
        return null;
    }

    return shouldShowCard && children;
};

export default CardLoader;
